import { render, staticRenderFns } from "./searchope2.vue?vue&type=template&id=c0f4f0f6"
import script from "./searchope2.vue?vue&type=script&lang=js"
export * from "./searchope2.vue?vue&type=script&lang=js"
import style0 from "./searchope2.vue?vue&type=style&index=0&id=c0f4f0f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports